var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section3"}},[_c('ty',{attrs:{"titles":_vm.p11s3titles,"videos":_vm.p11s3videos,"activo":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }